import service from "@/api/service";
import { VisitUserCSVGetRequest } from "@/api/analysis/visit-user-csv/request";
import { DownloadCSVResponse } from "@/api/response";

/**
 * 来店ユーザーCSV出力APIをコールします。
 *
 * @param getRequest 来店ユーザーCSV出力APIのリクエストボディ
 * @return response
 */
export async function get(getRequest: VisitUserCSVGetRequest) {
  const response = await service.postReceiveCSV(
    "/analysis-visit-user-csv",
    getRequest
  );
  return response as DownloadCSVResponse;
}
